import { useState } from 'react';
import { BookOpen, ChevronDown, Leaf } from 'lucide-react';

const CONSULTA_ITEMS = [
  'Acupuntura',
  'Osteopatía',
  'Masaje',
  'Técnica cráneo-sacral',
  'Naturopatía',
  'Suplementación natural',
  'Amatsu Tatara',
  'Hipnosis aplicada',
  'Anma (masaje tradicional japonés)',
  'Seitai (osteopatía tradicional japonesa)',
  'Ampuku (técnica abdominal japonesa)',
  'Vendaje neuromuscular (kinesiotape)',
  'Kinesiología',
  'Moxibustión',
  'Ventosas'
];

const CURSOS_ITEMS = [
  'Quiromasaje (6 meses)',
  'Técnica cráneo-sacral (3 meses)',
  'Acupuntura y moxibustión (2 años)',
  'Osteopatía (2 años)',
  'Anma (masaje tradicional japonés) (1 año)',
  'Vendaje neuromuscular (3 meses)'
];

const TherapiesSection = ({ imgBase }) => {
  const [open, setOpen] = useState(false);

  return (
    <section id="terapias" className="relative overflow-hidden bg-slate-900 py-32 text-white">
      <div className="absolute right-0 top-0 h-[500px] w-[500px] rounded-full bg-emerald-500/10 blur-[150px]" />
      <div className="container mx-auto px-6">
        <div className="grid items-center gap-20 lg:grid-cols-2">
          <div className="order-2 lg:order-1">
            <h2 className="mb-6 text-xs font-bold uppercase tracking-[0.5em] text-emerald-400">Salud Natural</h2>
            <h3 className="mb-10 text-5xl font-black leading-[1.1] tracking-tighter">Método Balance: <br /> Terapias Richard Atik</h3>
            <p className="mb-12 text-xl leading-relaxed text-slate-400">
              Recupera tu equilibrio biológico y emocional a través de terapias naturales personalizadas.{' '}
              <span className="font-semibold text-white">Bajo cita previa</span> (tlf / WhatsApp{' '}
              <a href="tel:+34670784860" className="text-emerald-400 hover:text-emerald-300">670 784 860</a>).
            </p>

            <div className="grid gap-6">
              <div className="group flex gap-6 rounded-[2rem] border border-white/10 bg-white/5 p-8 transition-all hover:bg-white/10">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-emerald-500/20 text-emerald-400 transition-colors group-hover:bg-emerald-500 group-hover:text-white"><Leaf size={32} /></div>
                <div>
                  <h4 className="mb-2 text-xl font-bold">Terapias en consulta</h4>
                  <p className="text-sm leading-relaxed text-slate-400">
                    Acupuntura, osteopatía, masaje, cráneo sacral, naturopatía, suplementación natural, anma, seitai,
                    ampuku, moxibustión, ventosas y otras técnicas integradas en el Método Balance.
                  </p>
                </div>
              </div>
              <div className="group flex gap-6 rounded-[2rem] border border-white/10 bg-white/5 p-8 transition-all hover:bg-white/10">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-emerald-500/20 text-emerald-400 transition-colors group-hover:bg-emerald-500 group-hover:text-white"><BookOpen size={32} /></div>
                <div>
                  <h4 className="mb-2 text-xl font-bold">Formación y cursos</h4>
                  <p className="text-sm leading-relaxed text-slate-400">
                    Programas de quiromasaje, técnica cráneo sacral, acupuntura y moxibustión, osteopatía, anma y
                    vendaje neuromuscular.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 rounded-[2rem] border border-white/10 bg-black/20">
              <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="flex w-full items-center justify-between gap-4 px-8 py-5 text-left text-xs font-bold uppercase tracking-widest text-emerald-300 hover:text-white"
              >
                Listado detallado (consulta y cursos)
                <ChevronDown size={20} className={`shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
              </button>
              {open && (
                <div className="grid gap-8 border-t border-white/10 px-8 pb-8 pt-6 md:grid-cols-2">
                  <div>
                    <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.3em] text-emerald-400">Consulta</p>
                    <ul className="list-disc space-y-2 pl-5 text-slate-300">{CONSULTA_ITEMS.map((item) => <li key={item}>{item}</li>)}</ul>
                  </div>
                  <div>
                    <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.3em] text-emerald-400">Cursos</p>
                    <ul className="list-disc space-y-2 pl-5 text-slate-300">{CURSOS_ITEMS.map((item) => <li key={item}>{item}</li>)}</ul>
                    <p className="mt-5 text-sm text-slate-300">
                      Más info: tlf / WhatsApp <a href="tel:+34670784860" className="font-semibold text-emerald-400">670 784 860</a>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="relative order-1 lg:order-2">
            <div className="absolute inset-0 rounded-[4rem] bg-emerald-500/20 blur-3xl" />
            <img
              src={`${imgBase}dojo/1742062714228.jpg`}
              className="relative z-10 aspect-square rounded-[4rem] object-cover brightness-75 grayscale shadow-2xl transition-all duration-1000 hover:grayscale-0"
              alt="Terapias Naturales Richard Atik"
              onError={(e) => {
                e.target.src = 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80&w=1000';
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TherapiesSection;
